/*
  Authored by Brett Barinaga on 11/17/21.
  Copyright (c) Kochava, Inc. All rights reserved.
*/
export var getPackageName = function () { return "com.".concat(window.location.hostname, ".web"); };
export var getLanguage = function () {
    return (navigator) ? navigator.language : "";
};
export var getDeviceWidth = function () {
    return (window) ? window.screen.availWidth : 0;
};
export var getDeviceHeight = function () {
    return (window) ? window.screen.availHeight : 0;
};
export var getDeviceOrientation = function () {
    return (window) ? window.innerWidth < window.innerHeight
        ? "portrait" : "landscape" : "";
};
export var getBaseDomain = function () {
    try {
        var regexResult = window.location.host.match(/[^.]*\.[^.]*$/);
        if (regexResult)
            return regexResult[0];
        return "";
    }
    catch (err) {
        return window.location.host;
    }
};
export var getPageName = function () {
    var page = "";
    if (window.location) {
        page = window.location.pathname.substring(1);
        page = page.replace(/\/+$/, "");
    }
    return page === "" ? "/" : page;
};
export var getUrlParameter = function (name) {
    if (!window.location || !window.location.search) {
        return "";
    }
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
};
